import React from 'react';
import { CONTAINER_STATUS_ENUM } from '../container-config';

interface Props {
  pickupAvailable?: string;
  pickupLocation?: string;
  pickupClosedArea?: boolean;
  status: string;
  terminalName?: string;
}

const tagClasses = 'px-1 py-0.5 rounded-sm';
const redClasses = 'text-red-900 bg-red-light';

const AvailabilityCellContainer: React.FC<{ terminalName?: string; children: React.ReactNode }> = ({
  terminalName,
  children,
}): JSX.Element => (
  <div className="leading-none flex h-full py-4 px-2">
    <div className="flex flex-col space-y-2 items-start">
      {terminalName && <h5 className="font-semibold text-gray-800 uppercase">{terminalName}</h5>}
      {children}
    </div>
  </div>
);

const AvailabilityCell: React.FC<Props> = ({
  pickupAvailable,
  pickupLocation,
  pickupClosedArea,
  status,
  terminalName,
}) => {
  if (status !== CONTAINER_STATUS_ENUM.IMPORT && status !== CONTAINER_STATUS_ENUM.ON_VESSEL) {
    return (
      <AvailabilityCellContainer terminalName={terminalName}>
        <h6>-</h6>
      </AvailabilityCellContainer>
    );
  }
  return (
    <AvailabilityCellContainer terminalName={terminalName}>
      <h6
        className={`uppercase max-w-max font-medium ${tagClasses} ${
          pickupAvailable ? 'text-green-600 bg-green-50' : redClasses
        }`}
      >
        {pickupAvailable ? 'Available for pickup' : 'Not available for pickup'}
      </h6>
      {status === CONTAINER_STATUS_ENUM.IMPORT && pickupLocation && (
        <h5 className="">Yard Location: {pickupLocation}</h5>
      )}
      {pickupClosedArea === true && <h6 className={`${tagClasses} ${redClasses}`}>Closed Area</h6>}
    </AvailabilityCellContainer>
  );
};

AvailabilityCell.displayName = 'ContainerTracking.AvailabilityCell';

export default AvailabilityCell;
